import { c as _c } from "react/compiler-runtime";
import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe';
import { queryParametersSchema } from '@/schemas/room';
import { useParams, useSearchParams } from 'next/navigation';
export const useEnableViewMode = () => {
  const $ = _c(2);
  const {
    roomId
  } = useParams();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const viewModeParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.VIEW);
    t0 = queryParametersSchema.safeParse({
      view: viewModeParam
    });
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parseResult = t0;
  const enableViewMode = Boolean(roomId && parseResult.success && parseResult.data.view);
  return enableViewMode;
};